(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-spotlight"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slides = Array.from(document.querySelectorAll('.keiso-spotlight-slide'));
  const leftBtn = document.querySelector('.keiso-spotlight-arrow--left');
  const rightBtn = document.querySelector('.keiso-spotlight-arrow--right');
  let center = 0;

  function updateSlides() {
    slides.forEach((slide, idx) => {
      slide.classList.remove('is-active', 'is-visible');
      if(idx === center) {
        slide.classList.add('is-active', 'is-visible');
      } else if(idx === center - 1 || idx === center + 1) {
        slide.classList.add('is-visible');
      }
    });
    // Disabilita le frecce ai limiti
    leftBtn.disabled = center === 0;
    rightBtn.disabled = center === slides.length - 1;
    // Gestione video: solo centrale parte e ha controlli
    slides.forEach((slide, idx) => {
      const video = slide.querySelector('video');
      if(video){
        if(slide.classList.contains('is-active')){
          video.controls = true;
          video.muted = true;
          video.play();
        } else {
          video.controls = false;
          video.pause();
          video.currentTime = 0;
          video.load();
        }
      }
    });
  }

  leftBtn.addEventListener('click', function() {
    if(center > 0){
      center--;
      updateSlides();
    }
  });
  rightBtn.addEventListener('click', function() {
    if(center < slides.length - 1){
      center++;
      updateSlides();
    }
  });

  slides.forEach((slide, idx) => {
    slide.addEventListener('click', function() {
      if(idx !== center){
        center = idx;
        updateSlides();
      }
    });
  });

  // Inizializza
  updateSlides();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
